// 项目管理
export default [
  {
    path: '/formalProject',
    // name: 'formalProject',
    meta: { title: '项目管理' },
    component: () => import('../views/formalProject/index'),
    children: [
      
      {
        path: '/formalProject/projectList',
        // name: 'projectList',
        meta: { title: '正式项目列表', isMenu: true },
        component: () => import('../views/formalProject/projectList'),
      },
      {
        path: '/formalProject/detail/modify',
        // name: 'modify',
        meta: { title: '修改项目' },
        component: () => import('../views/formalProject/detail/modify'),
      },
      {
        path: '/formalProject/detail/addProduct',
        name: 'addProduct',
        meta: { title: '新增项目' },
        component: () => import('../views/formalProject/detail/addProduct'),
      },
      {
        path: '/formalProject/examine',
        // name: 'examine',
        meta: { title: '项目审核', isMenu: true },
      },
      {
        path: '/formalProject/examine/projectExamine',
        // name: 'projectExamine',
        meta: { title: '项目审核列表', isMenu: true },
        component: () => import('../views/formalProject/projectExamine'),
      },
      {
        path: '/formalProject/examine/detail/projectInfo',
        // name: 'projectExamine',
        meta: { title: '项目详情' },
        component: () => import('../views/formalProject/detail/projectInfo'),
      },
      {
        path: '/formalProject/examine/setMenuExamine',
        // name: 'setMenuExamine',
        meta: { title: '套餐审核列表', isMenu: true },
        component: () => import('../views/formalProject/setMenuExamine'),
      },
      {
        path: '/formalProject/examine/detail/setMenuInfo',
        name: 'setMenuInfo',
        meta: { title: '套餐详情' },
        component: () => import('../views/formalProject/detail/setMenuInfo'),
      },
      {
        path: '/formalProject/detail/examineDetail',
        // name: 'examineDetail',
        meta: { title: '查看项目审核' },
        component: () => import('../views/formalProject/detail/examineDetail'),
      },
      {
        path: '/formalProject/project',
        // name: 'project',
        meta: { title: '分类列表', isMenu: true },
        component: () => import('../views/formalProject/project'),
      },
      {
        path: '/formalProject/projectSetMenu',
        // name: 'project',
        meta: { title: '项目套餐列表', isMenu: true },
        component: () => import('../views/formalProject/projectSetMenu'),
      },
      {
        path: '/formalProject/detail/addSetMenu',
        // name: 'project',
        meta: { title: '项目套餐新增'},
        component: () => import('../views/formalProject/detail/addSetMenu'),
      },
      {
        path: '/formalProject/detail/modifyMenu',
        // name: 'project',
        meta: { title: '项目套餐修改'},
        component: () => import('../views/formalProject/detail/modifyMenu'),
      },
    ],
  },
];
